export default from './input-toggle';



// WEBPACK FOOTER //
// ./app/components/input-toggle/index.js